export function formatChipLabel(text: string | null | undefined): string {
  if (!text) return ""
  return text
    .replace(/_/g, " ")
    .trim()
    .split(/\s+/)
    .map((word) => {
      if (word.includes("-")) {
        return word
          .split("-")
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
          .join("-")
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(" ")
}

export function getSeverityStyle(severity: string): { bg: string; color: string } {
  switch (severity?.toLowerCase()) {
    case "critical":
      return { bg: "#FED7D7", color: "#9B2C2C" }
    case "warning":
      return { bg: "#FEEBC8", color: "#7B341E" }
    case "info":
      return { bg: "#BEE3F8", color: "#2B6CB0" }
    default:
      return { bg: "#EDF2F7", color: "#4A5568" }
  }
}

export function parseTimeWindowInput(value: string, currentUnit: "h" | "m" | "s"): number | null {
  const num = parseFloat(value)
  if (isNaN(num) || num <= 0) return null
  switch (currentUnit) {
    case "h": return num * 3600
    case "m": return num * 60
    case "s": return num
  }
}

export function getTimeWindowDisplayValue(seconds: number): { value: number; unit: "h" | "m" | "s" } {
  if (seconds >= 3600 && seconds % 3600 === 0) return { value: seconds / 3600, unit: "h" }
  if (seconds >= 60 && seconds % 60 === 0) return { value: seconds / 60, unit: "m" }
  return { value: seconds, unit: "s" }
}

/** Whether a Standard Alert applies to an Asset of this class: one naming no classes applies to all. */
export function appliesToClass(assetClasses: string[] | null | undefined, assetClass: string | null | undefined): boolean {
  if (!assetClasses?.length) return true
  return assetClasses.some((c) => c.toLowerCase() === (assetClass ?? "").toLowerCase())
}
